import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import './WorkOrderItemsEdit.scss';

const PromptInputModal = ({
  open,
  onHide,
  data,
  setData,
  title = 'Updating Order?',
  heading = 'Specify Reason',
  placeholder = 'Write the reason here',
  buttonText = 'Save Changes',
  onSubmit,
  danger = false,
  isProgress,
  isEdit,
}) => {
  const [goToNextStep, setGoToNextStep] = useState(false);

  const handleChangeInput = (e) => setData(e.target.value);

  const renderBodyContent = () => {
    if (isProgress && isEdit) {
      if (goToNextStep) {
        return (
          <>
            <h3 className="editsavedmodalreason mb-2">{heading}</h3>
            <textarea
              className="editsavedmodalinput"
              value={data}
              maxLength={600}
              onChange={handleChangeInput}
              placeholder={placeholder}
            />
          </>
        );
      } else {
        return (
          <h3 className="editsavedmodalreason mb-2">
            Saving these changes will impact the previous margins of this work order, are you sure
            you want to continue?
          </h3>
        );
      }
    }

    return (
      <>
        <h3 className="editsavedmodalreason mb-2">{heading}</h3>
        <textarea
          className="editsavedmodalinput"
          value={data}
          maxLength={600}
          onChange={handleChangeInput}
          placeholder={placeholder}
        />
      </>
    );
  };

  return (
    <Modal show={open} onHide={onHide} centered size="lg">
      <Modal.Header className="editsavedmodalheader" closeButton>
        {goToNextStep || !isProgress ? title : 'Confirmation Modal'}
      </Modal.Header>
      <Modal.Body>{renderBodyContent()}</Modal.Body>
      <Modal.Footer>
        {isProgress && isEdit && !goToNextStep ? (
          <>
            <Button
              variant="outline"
              className="editsavedmodalbutton"
              onClick={() => setGoToNextStep(true)}>
              Yes
            </Button>
            {/* <Button
              variant="outline-secondary"
              disabled={!data || data.length === 0}
              onClick={onHide}>
              No
            </Button> */}
          </>
        ) : (
          <Button
            variant="outline"
            className={danger ? 'closewomodalbutton' : 'editsavedmodalbutton'}
            disabled={!data || data.length === 0}
            onClick={onSubmit}>
            {buttonText}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default PromptInputModal;
